import Vue from 'vue'
import ChargingPointRepository from '@repository/ChargingPointRepository'

/**
 * Le classement des bornes (constructeurs › gammes › types), chargé une fois et partagé : les choix d'une restriction
 * de mise en service, et les noms à afficher pour les identifiants qu'elle garde.
 */
const state = Vue.observable({ manufacturers: [], names: {} })
let loading = null

export function loadClassification() {
  if (!loading) {
    loading = ChargingPointRepository.classification().then(manufacturers => {
      const names = {}
      for (const manufacturer of manufacturers) {
        for (const line of manufacturer.productLines) {
          if (line.id) {
            names[line.id] = `${manufacturer.name} · ${line.name}`
          }
          for (const type of line.types) {
            names[type.id] = `${manufacturer.name} · ${type.model || type.modelLabel || '?'}`
          }
        }
      }
      state.manufacturers = manufacturers
      state.names = names
      return manufacturers
    }).catch(err => {
      loading = null
      throw err
    })
  }
  return loading
}

/** Le nom d'une gamme ou d'un type d'après son identifiant (l'identifiant tant que le classement n'est pas chargé). */
export function classificationName(id) {
  return state.names[id] || id
}

export const classification = state
